module.exports = __webpack_public_path__ + "static/media/Zinc-Screenshot-1.9ceee696.png";